import React from "react";

const RedGem = ({ className }) => {
  return (
    <svg
      id="Capa_1"
      enable-background="new 0 0 512 512"
      viewBox="0 0 512 512"
      className={className}
    >
      <g>
        <path
          d="m252.903 27.118h-121.598c-4.374 0-8.575 2.096-11.703 5.84l-114.573 137.115c-3.661 4.382-5.297 10.263-4.994 16l211.716 75.958z"
          fill="#ff5f66"
        />
        <path
          d="m506.855 170.33-111.112-130.599-5.865-6.898c-3.119-3.668-7.275-5.716-11.598-5.716h-123.797l58.35 208.722 199.149-49.767c.213-5.672-1.475-11.449-5.127-15.742z"
          fill="#fa184b"
        />
        <path
          d="m.036 186.073c.288 5.441 2.318 10.753 6.071 14.526l237.351 279.643c2.48 2.493 5.4 3.968 8.405 4.459l-68.788-298.628z"
          fill="#fa184b"
        />
        <path
          d="m326.076 186.073v.26l-69.797 298.372c3.011-.487 5.938-1.961 8.424-4.457l241.176-279.259c3.847-3.865 5.894-9.34 6.103-14.916z"
          fill="#d3003c"
        />
        <path
          d="m349.962 186.073-96.255-33.791-92.354 33.791 90.509 298.628c1.466.24 2.95.241 4.417.004l93.838-298.372z"
          fill="#ff5f66"
        />
        <path
          d="m253.707 186.073v298.794c.859.024 1.718-.024 2.572-.162l93.838-298.372-.156-.26z"
          fill="#fa184b"
        />
        <path
          d="m349.962 186.073-95.479-158.955h-1.58l-91.55 158.955z"
          fill="#fa184b"
        />
        <path
          d="m253.707 186.073h96.255l-95.479-158.955h-.776z"
          fill="#d3003c"
        />
      </g>
    </svg>
  );
};

export default RedGem;
